import { Tag } from 'antd';
import styled from 'styled-components';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { type IHiddenWidget } from './IHiddenWidget.ts';

const HiddenWidgetPreviewStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 6px 12px;
  position: relative;
  min-height: 40px;
  border-radius: ${props => props.theme.borderRadius}px;

  background-color: ${props => props.theme.colorPrimaryBorder};
`;

const HiddenWidgetPreviewDescription = styled.div`
  display: flex;
  justify-content: left;
  align-items: left;
  text-align: left;
  padding: 3px 6px;
  font-style: italic;
  width: 75%;
  margin: 0 auto;
`;

export interface IHiddenWidgetPreviewComponentProps
  extends IWidgetComponentProps<IHiddenWidget> {}

export function HiddenWidgetPreviewComponent(
  props: IHiddenWidgetPreviewComponentProps,
) {
  const { widget } = props;
  return (
    <HiddenWidgetPreviewStyled>
      <Tag color="red">
        Campo Nascosto{widget.code ? `: ${widget.code}` : ''}
      </Tag>
      {widget.notes && (
        <HiddenWidgetPreviewDescription>
          {widget.notes}
        </HiddenWidgetPreviewDescription>
      )}
    </HiddenWidgetPreviewStyled>
  );
}
